"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrowLeft(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M8.48 3.15a.766.766 0 01.998.074l.074.086c.222.3.198.726-.074.998L2.615 11.17h20.619a.766.766 0 01.104 1.525l-.104.007H2.615l6.863 6.863.074.086a.766.766 0 01-1.157.997l-8.17-8.17-.065-.074a.767.767 0 01-.16-.468v-.016a.77.77 0 01.004-.062L0 11.936a.77.77 0 01.224-.541l-.07.08a.77.77 0 01.07-.08l8.17-8.17z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgArrowLeft;
exports.default = _default;